import { LitElement } from 'lit';
import { unsafeStatic, html } from "lit/static-html.js";
import { i18n } from '@lingui/core';
import { activateI18n } from '../src/utils/i18n';
const msgs = {"nb":{},"en":{},"fi":{},"da":{},"sv":{}}
activateI18n(msgs.en, msgs.nb, msgs.fi, msgs.da, msgs.sv);


export class IconNettbilLight42 extends LitElement {
  render() {
      const title = i18n.t({ message: `Nettbil`, id: 'icon.title.nettbillight', comment: 'Title for NettbilLight icon' });
      
      return html`<svg xmlns="http://www.w3.org/2000/svg"width="42"height="28"fill="none"viewBox="0 0 42 28" part="w-icon-nettbil-light-42-part">${unsafeStatic(`<title>${title}</title>`)}<path fill="#044046" d="M9.698 24c3.148 0 5.699-2.537 5.699-5.667s-2.551-5.666-5.699-5.666C6.551 12.666 4 15.203 4 18.332 4 21.463 6.551 24 9.698 24m22.604 0c3.148 0 5.699-2.537 5.699-5.667s-2.551-5.666-5.699-5.666-5.698 2.537-5.698 5.666S29.155 24 32.302 24"></path><path fill="#FF8752" d="M32.302 18.24H9.698C9.698 12.031 14.758 7 21 7s11.302 5.032 11.302 11.24"></path></svg>`; }
}
if (!customElements.get('w-icon-nettbil-light-42')) {
  customElements.define('w-icon-nettbil-light-42', IconNettbilLight42);
}